module.exports = __webpack_public_path__ + "static/media/22.a9680ab1.png";